import React, { Component } from 'react'
import { InitativeCard, RecognitionCard, RecognitionCardV2 } from '../PersonalProfile/style';
import PropTypes from 'prop-types';
import { ImageUrl } from '../../utils/constants';
import moment from 'moment';
import { OverviewCard, InitiativesCard, WellnessCardNew, InterestCardNew, DropdownContentNew, DropdownContent, InterestCard } from './styles';
import {  fetchApi } from '../../utils/methods';
import { withTranslation } from 'react-i18next';
import ProfileEditForm from './ProfileEditForm';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { putUpdateUserData, getUserProfile, getUserCompanyItitiatives, getWellnessInterests, getUser } from '../../redux/actions';
import dayjs from 'dayjs';
import { AdminRightArrowIcon, Checkmark, EditIconNew, DropIcon, UserDashboardIcon, } from '../../utils/icons';
import UserInitiativePopup from '../UserDashboard/Initiatives/userInitiativePopup';
import ConfirmDetailsModal from '../ContentV2/SideBarContiner/ConfirmDetailsModal';
import InitiativeCompleteModal from '../UserDashboard/Initiatives/initiativeCompleteModal';
import { UpdateWellnessInterests } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';

const DynamicOverviewCard = styled(OverviewCard)`
  height: ${(props) => props.isEditMode ? 'auto' : '360px'};
  min-height: ${(props) => props.isEditMode ? '600px' : '360px'};
`;

const DynamicWellnessCard = styled(WellnessCardNew)`
  min-height: ${(props) => props.isEditMode ? '400px' : 'auto'};
`;

const WellnessData = [
  "Individual Sports",
  "Water Sports",
  "Ball Sports",
  "Wheel Sports",
  "Winter Sports",
  "Combat Sports",
  "Resistance Training",
  "Other"
];

class OverviewV3 extends Component {

  recognitionRef = React.createRef();
  profileEditFormRef = null;

  constructor(props) {
    super(props);
    this.state = {
      isEditMode: false,
      isInterestEditMode: false,
      showPopup: false,
      initiativeData: {},
      showConfirmVisitModal: false,
      isConfirmDetails: false,
      selectedInterests: [],
      activeIndex: []
    };
  }

  componentDidMount() { 
    this.scrollToSection();
    this.props.getUserCompanyItitiatives();
    const { fetchWellnessInterests, wellnessInterests } = this.props;
    if (!wellnessInterests) fetchWellnessInterests();
    window.console.log(fetchWellnessInterests,'fetchWellnessInterests')
  }
  
  componentDidUpdate(prevProps) {
    if (
      this.props.history.location !== prevProps.history.location ||
      this.props.companyBranding?.company_branding?.show_biometric !== prevProps.companyBranding?.company_branding?.show_biometric ||
      this.props.companyBranding?.company_branding?.show_recognition !== prevProps.companyBranding?.company_branding?.show_recognition
    ) {
      this.scrollToSection();
    }
  }

  scrollToSection = () => {
    const scrollTo = this.props.history.location.state?.scrollTo;
    const tryScroll = () => {
      const el = scrollTo === "recognition-received" ? this.recognitionRef.current : document.getElementById(scrollTo);
      if (el) {
        const headerOffset = 0;
        const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        this._scrollRetries = (this._scrollRetries || 0) + 1;
        if (this._scrollRetries < 10) window.setTimeout(tryScroll, 100);
      }
    };
    window.requestAnimationFrame(tryScroll);
  };

  toggleEditMode = () => {
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleButtonClick = () => {
    if (this.state.isEditMode) {
      if (this.profileEditFormRef) {
        this.profileEditFormRef.handleSave();
      }
    } else {
      this.toggleEditMode();
    }
  };

  handleInterestButtonClick = () => {
    if (this.state.isInterestEditMode) {
      this.handleSaveWellnessInterests();
    } else {
      const { interest } = this.props;
      const selected = interest?.map((item) => item.interest_id) || [];
      this.setState({ 
        isInterestEditMode: true,
        selectedInterests: selected,
        activeIndex: [0]
      });
    }
  };

  handleInterestToggle = (interestId) => {
    this.setState((prevState) => {
      const { selectedInterests } = prevState;
      if (selectedInterests.includes(interestId)) {
        return { selectedInterests: selectedInterests.filter((id) => id !== interestId) };
      } else {
        return { selectedInterests: [...selectedInterests, interestId] };
      }
    });
  };

  handleSaveWellnessInterests = async () => {
    const { selectedInterests } = this.state;
    const { user } = this.props;
    
    const payload = {
      uid: user.uid,
      aoi: selectedInterests
    };

    try {
      const res = await fetchApi(UpdateWellnessInterests, "POST", payload);
      if (res?.status === "success") {
        toast.success("Wellness interests updated successfully");
        this.setState({ isInterestEditMode: false, activeIndex: [] });
        this.props.getUserProfileDetails();
        this.props.getUser();
      } else {
        toast.error(res?.data?.message || "Failed to update wellness interests");
      }
    } catch (error) {
      toast.error("Error updating wellness interests");
    }
  };

  handleDropDown = (index) => {
    this.setState((prevState) => {
      const { activeIndex } = prevState;
      if (activeIndex.includes(index)) {
        return { activeIndex: activeIndex.filter((i) => i !== index) };
      } else {
        return { activeIndex: [...activeIndex, index] };
      }
    });
  };

  handleSaveData = (data) => {
    const { updateUserDataDetails, getUserProfileDetails } = this.props;
    const hasChanges = data.hasChanges;
    delete data.hasChanges; // Remove this flag before sending to API
    
    if (hasChanges) {
      updateUserDataDetails(data, () => {
        this.setState({ isEditMode: false });
        getUserProfileDetails();
      });
    } else {
      // Just toggle edit mode without API call
      this.setState({ isEditMode: false });
    }
  };


  handleCancel = () => {
    this.setState({ isEditMode: false });
  };

  showInitiativeModal = (data) => {
    this.setState({ showPopup: true, initiativeData: data });
  };

  hideInitiativeModal = () => {
    this.setState({ showPopup: false });
  };

  showConfirmVisitModal = () => {
    this.setState({ showConfirmVisitModal: true });
    this.hideInitiativeModal();
  };

  hideConfirmVisitModal = () => {
    this.setState({ showConfirmVisitModal: false });
  };

  showIsConfirmDetails = () => {
    this.setState({ isConfirmDetails: true });
    this.hideConfirmVisitModal();
  };

  hideIsConfirmDetails = () => {
    this.setState({ isConfirmDetails: false });
  };

  render() {
    const { user, interest, userRecognitionCount, userInitiativesData, wellnessInterests, history, isAdminView } = this.props;
    const { isEditMode, isInterestEditMode, showPopup, initiativeData, showConfirmVisitModal, isConfirmDetails, selectedInterests, activeIndex } = this.state;
    
    let TotalRecognitionPoints = 0;
    userRecognitionCount && userRecognitionCount.length > 0 && userRecognitionCount.map((item) => {
      TotalRecognitionPoints = TotalRecognitionPoints + item.count;
    })
    const RegistrationDate = user && user.created_at ? moment(user.created_at).format("MM/DD/YYYY") : "NA";
    const Birthday = user && user.birthday ? moment(user.birthday).format("MM/DD/YYYY") : "NA";
    const WorkAnniversaryDate = user && user.work_anniversary_date ? moment(user.work_anniversary_date).format("MM/DD/YYYY") : "NA";

    return (
      <div>
        <DynamicOverviewCard isEditMode={isEditMode}>
          <div className='prof-details'>
            <div className='name-in'>{this.props.t("Personal Details")}</div>
            {!isAdminView && (
              <button onClick={this.handleButtonClick} className={`user-edit-btn ${!isEditMode ? 'no-background' : ''}`}>
                {isEditMode ? (
                  <>
                    {this.props.t("Save Changes")}
                    <span style={{ marginLeft: '8px' , marginTop: '-3px'}}>{Checkmark()}</span>
                  </>
                ) : (
                  <>
                    {this.props.t("Edit")}
                    <span style={{ marginLeft: '8px' }} >{EditIconNew()}</span>
                  </>
                )}
              </button>
            )}
          </div>
          <div className='view-card'>
            {!isEditMode || isAdminView ? (
              <div className='emp-detail'>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("First name")} </div>
                  <div className='prof-data'>{user && user.fname} </div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Last name")} </div>
                  <div className='prof-data'>{user && user.lname}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Company")} </div>
                  <div className='prof-data'>{user && user.company_name !== null ? user.company_name : "NA"}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Location")} </div>
                  <div className='prof-data'>{user && user.city !== null ? user.city : "NA"}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Email")} </div>
                  <div className='prof-data'>{user && user.mail !== null ? user.mail : "NA"}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Country")} </div>
                  <div className='prof-data'>{user && user.country !== null ? user.country : "NA"}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Contact")} </div>
                  <div className='prof-data'>{user && user.phone_number !== null ? user.phone_number : "NA"}</div>
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Birthday")}{user && user.birthday !== null && (
                    <span style={{ marginLeft: '2px', color: '#989898', fontSize: '16px' }}>
                      ({user.visible_birthday ? 'Public' : 'Private'})
                    </span>
                  )}: </div>
                  
                  <div className='color'>
                    {/* {user && user.birthday !== null ? convertMonthFromDate(moment(user.birthday).format("DD MMMM YYYY"), this.props) : "NA"} */}
                    {user && user.birthday ? Birthday : "NA"}
                  </div>
                </div>
                <div className='fieldNames' style={{borderBottom:'none'}}>
                  <div className='label-name-emp'>{this.props.t("Registration Date")} </div>
                  <div className='prof-data'>{user && user.created_at ? RegistrationDate : "NA"}</div>
                </div>
                <div className='fieldNames' style={{borderBottom:'none'}}>
                  <div className='label-name-emp'>{this.props.t("Work Anniversary")} </div>
                  <div className='green'>{user && user.work_anniversary_date ? WorkAnniversaryDate : "NA"}</div>
                  {/* <div className='green'>{user && user.work_anniversary_date !== null ? convertMonthFromDate(moment(user.work_anniversary_date).format("DD MMMM YYYY"), this.props) : "NA"}</div> */}
                </div>
              </div>
            ) : (
              <ProfileEditForm 
                onRef={(ref) => { this.profileEditFormRef = ref; }}
                user={user}
                onSave={this.handleSaveData}
                onCancel={this.handleCancel}
                // showAdminFields={showAdminFields}
              />
            )}
          </div>
        </DynamicOverviewCard>

        {interest && interest.length > 0 && (
          <DynamicWellnessCard isEditMode={isInterestEditMode} style={{background:'none', padding:'0'}}>
            <div className='prof-details' style={{display:'flex', justifyContent:'space-between'}}>
              <div className='name-in'>{this.props.t("Wellness Interests")}</div>
              {!isAdminView && (
                <button onClick={this.handleInterestButtonClick} className={`user-edit-btn ${!isInterestEditMode ? 'no-background' : ''}`}>
                  {isInterestEditMode ? (
                    <>
                      {this.props.t("Save Changes")}
                      <span style={{ marginLeft: '8px',marginTop: '-3px' }}>{Checkmark()}</span>
                    </>
                  ) : (
                    <>
                      {this.props.t("Edit")}
                      <span style={{ marginLeft: '8px' }}>{EditIconNew()}</span>
                    </>
                  )}
                </button>
              )}
            </div>
            <div className='view-card' style={{marginTop: '10px'}}>
              <div style={{background: '#fff', borderRadius: '12px', border:'0.75px solid #DCDCDC'}}>
                {!isInterestEditMode || isAdminView ? (
                  WellnessData.map((data,index)=>{
                    const categoryInterests = wellnessInterests?.filter((listData) => 
                      listData?.interest_type?.toLowerCase().trim() === data.toLowerCase().trim() &&
                      interest?.some((item) => item?.interest_id === listData?.id)
                    );
                    
                    if (!categoryInterests || categoryInterests.length === 0) return null;
                    
                    return (
                      <InterestCardNew key={index}>
                        <div className="title" style={{color:'#989898'}}>{data}</div>
                        <div className="dropdown-wrapper">
                          {categoryInterests.map((listData, idx) => (
                            <DropdownContentNew userInterest={true} key={idx}>
                              <img src={`${ImageUrl}/${listData?.interest_white_icon}`} className='category-img'/>
                              <div className="listContent">{listData?.name}</div>
                            </DropdownContentNew>
                          ))}
                        </div>
                      </InterestCardNew>
                    );
                  })
                ) : (
                  WellnessData.map((data,index)=>(
                    <InterestCard key={index}>
                      <div className="interest-container" onClick={()=>this.handleDropDown(index)}>
                        <div className="interestType">{data}</div>
                        <div style={{ transform: activeIndex.includes(index) ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease"}} className="dropicon"> {DropIcon("#DA6C74")}</div>
                      </div>
                      {activeIndex.includes(index) && (
                        <div className="dropdown-wrapper">
                          {wellnessInterests?.map((listData, idx) => {
                            const isMatchingInterest = selectedInterests.includes(listData?.id);
                            if (data.toLowerCase().trim() === listData?.interest_type?.toLowerCase().trim()) {
                              return (
                                <DropdownContent 
                                  userInterest={isMatchingInterest} 
                                  key={idx}
                                  onClick={() => this.handleInterestToggle(listData?.id)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <img src={`${ImageUrl}/${isMatchingInterest ? listData?.interest_white_icon : listData?.interest_color_icon}`} className='category-img'/>
                                  <div className="listContent">{listData?.name}</div>
                                </DropdownContent>
                              );
                            }
                          })}
                        </div>
                      )}
                    </InterestCard>
                  ))
                )}
              </div>
            </div>
          </DynamicWellnessCard>
        )}

        {this.props.companyBranding?.company_branding?.show_biometric ?
          <InitativeCard justify>
            <div className='company-initative'>
              <div className='heading' style={{marginBottom:'10px'}}>
                My Company Initiatives
              </div>
              
              <div className='fitness-wrapper' style={{flexWrap:"wrap", gap:"20px 20px",padding:'0'}}>
                {userInitiativesData?.map((data, index) => {
                  const completedDate = dayjs(new Date(data?.date)).format("MMM DD");
                  return (
                    <InitiativesCard key={index} color={data?.color}>
                      <div className='icon'>
                        <img src={ImageUrl + "/" + data?.initiative_white_icon} alt="icon"/>
                      </div>
                      <div className='wrap'>
                        <div className='title'>{data?.name}</div>
                        <div className='points'>+{data?.points} pts</div>
                        {data?.is_taken ? 
                          <div className='completed'>Completed on {completedDate}</div> :
                          !isAdminView && (
                            <div className='initiative-button' onClick={() => this.showInitiativeModal(data)}>
                              Log Initiative {AdminRightArrowIcon("#DA6C74")}
                            </div>
                          )
                        }
                      </div>
                    </InitiativesCard>
                  );
                })}
              </div>
            </div>
          </InitativeCard> : null}
        <div ref={this.recognitionRef}>
          {this.props.companyBranding?.company_branding?.show_recognition && 
            userRecognitionCount?.some((item) => item.count > 0) ? (
              <RecognitionCard>
                <div className='recognize-received'>
                  <div className='heading2'>
                    {this.props.t("My")} {moment().format('YYYY')} {this.props.t("Recognitions Received")} 
                  </div>
                  
                  <div className='welcome-wrapper'>
                    {userRecognitionCount
                      .filter((item) => item.count > 0)
                      .map((item, index) => (
                        <RecognitionCardV2
                          key={index}
                          marginRight={(index + 1) % 4 === 0 ? "0px" : "25px"}
                          backgroundColor={item.color}
                          color="#092F41"
                        >
                          <div className='imgNew'>
                            <img src={`${ImageUrl}/${item.icon}`} />
                          </div>
                          <div className='welldone-card-text' title={item.name}>{this.props.t(item.name)}
                            <div className='point'>{this.props.t(item.count)}</div>
                          </div>
                        </RecognitionCardV2>
                      ))}
                  </div>
                </div>
              </RecognitionCard>
            ) : null}
        </div>
        {user && user.company_id === 1 &&<RecognitionCard id="product-tours">
          <div className='recognize-received'>
            <div className='heading2'>
              My Product Tours
            </div>
            <div className='welcome-wrapper'>
              <RecognitionCardV2
                marginRight="25px"
                backgroundColor="#DADAAE"
                onClick={() => {
                  localStorage.setItem('start_product_tour', 'true');
                  history.push('/portal');
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className='imgNew'>
                  {UserDashboardIcon('#092F41')}
                </div>
                <div className='welldone-card-text' title="User Dashboard">
                  {this.props.t("User Dashboard")}
                </div>
                <div className='point'>{AdminRightArrowIcon("#DA6C74")}</div>
              </RecognitionCardV2>
            </div>
          </div>
        </RecognitionCard>}

        {showPopup && !isAdminView && <UserInitiativePopup
          showPopup={showPopup}
          initiativeData={initiativeData}
          history={this.props.history}
          user={user}
          onClose={this.hideInitiativeModal}
          showConfirmVisitModal={this.showConfirmVisitModal}
          title={'Recommended To Complete'}
        />}
        {showConfirmVisitModal && !isAdminView && <ConfirmDetailsModal 
          showConfirmVisitModal={showConfirmVisitModal} 
          hideConfirmVisitModal={this.hideConfirmVisitModal} 
          showIsConfirmDetails={this.showIsConfirmDetails} 
          hideIsConfirmDetails={this.hideIsConfirmDetails} 
          initiativeData={initiativeData} 
          name={user?.fname} 
          getUserCompanyItitiatives={this.props.getUserCompanyItitiatives} 
        />}
        {isConfirmDetails && !isAdminView && <InitiativeCompleteModal 
          isConfirmDetails={isConfirmDetails} 
          initiativeData={initiativeData} 
          hideIsConfirmDetails={this.hideIsConfirmDetails}
        />}
      </div>
    )
  }
}

OverviewV3.propTypes = {
  userModal: PropTypes.func,
  user: PropTypes.object,
  interest: PropTypes.object,
  wellnessInitiatives: PropTypes.array,
  userRecognitionCount: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  companyBranding: PropTypes.object,
  updateUserDataDetails: PropTypes.func,
  getUserProfileDetails: PropTypes.func,
  getUserCompanyItitiatives: PropTypes.func,
  userInitiativesData: PropTypes.array,
  wellnessInterests: PropTypes.array,
  fetchWellnessInterests: PropTypes.func,
  isAdminView: PropTypes.bool,
  setUserDetails: PropTypes.object,
  shoutOutData: PropTypes.object,
  userConnectedDevice: PropTypes.array,
  role: PropTypes.string,
  getUser: PropTypes.func
};

const mapStateToProps = (state) => ({
  userInitiativesData: state.profileData.userInitiatives,
  wellnessInterests: state.register.wellnessInterests
});

const mapDispatchToProps = (dispatch) => ({
  updateUserDataDetails: (userData, callback) => dispatch(putUpdateUserData(userData, callback)),
  getUserProfileDetails: () => dispatch(getUserProfile()),
  getUserCompanyItitiatives: () => dispatch(getUserCompanyItitiatives()),
  fetchWellnessInterests: () => dispatch(getWellnessInterests()),
  getUser: () => dispatch(getUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OverviewV3));
